import { Box, Button, Dialog, DialogContent, Grid, Typography, useMediaQuery } from "@mui/material";
import WhiteInosio from "../../../icons/whiteinosio.svg";
import PaymentHistoryNew from "../../../icons/PaymentHistoryNew.svg";
import InosioIllustration from "../../../icons/InosioIllustration.svg";
import Wallet1 from "../../../icons/Wallet1.svg";
import { PaymentRequestBalanceDto } from "@inosio/payments-sdk";


interface CreateYourAccountWithInosioProp {
    open: boolean;
    onCreateAccount: () => void
    PaymentRequestDetails: PaymentRequestBalanceDto | null;
}

const CreateYourAccountWithInosioModal = (props: CreateYourAccountWithInosioProp) => {
    const { open, onCreateAccount, PaymentRequestDetails } = props
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const style = {
        height: isOnMobileScreen ? "100%" : "523px",
    };

    return (
        <Dialog
            open={open}
            fullScreen={isOnMobileScreen}
            BackdropProps={{
                invisible: true,
            }}
            fullWidth={true}
            disableEnforceFocus
            style={{
                background: "none",
            }}
            PaperProps={{
                style: {
                    pointerEvents: "auto",
                    borderRadius: isOnMobileScreen ? "0px" : "24px",
                    width: isOnMobileScreen ? "100%" : "472px",
                    boxShadow: "none",
                    overflow: "hidden"
                },
            }}
            disableEscapeKeyDown={true}

        >
            <DialogContent>
                <Box sx={style}>
                    <Grid item display='flex' justifyContent='space-between' flexDirection='column' sx={{ height: '100%' }} >
                        <Grid item display="flex" flexDirection="column">
                            {isOnMobileScreen ?
                                <Grid item display='flex' justifyContent='center'>
                                    <Grid item display='flex' pl={4} sx={{ width: '340px' }}>
                                        <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                                        <Typography
                                            sx={{
                                                fontFamily: "Work Sans",
                                                fontStyle: 'normal',
                                                fontWeight: 700,
                                                fontSize: '18px',
                                                lineHeight: '23px',
                                                color: '#14142B',
                                                textAlign: 'left',
                                                padding: '15px'
                                            }}>
                                            {PaymentRequestDetails?.CompanyName}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                : <></>}
                            <Typography sx={{
                                fontFamily: "Work Sans",
                                fontStyle: 'normal',
                                fontWeight: 700,
                                fontSize: '18px',
                                lineHeight: '23px',
                                color: '#14142B',
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: '30px'
                            }}>
                                Create your account with Inosio to:
                            </Typography>
                            <Grid item pt={8} display="flex" justifyContent='start'>
                                <img src={Wallet1} alt='Wallet1' />
                                <Typography
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                        textAlign: 'justify',
                                        marginTop: '10px'
                                    }} pl={4}>
                                    Save your payment method for the next time.
                                </Typography>
                            </Grid>
                            <Grid item pt={4} display="flex">
                                <img src={PaymentHistoryNew} alt='payments ' />
                                <Typography
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                        textAlign: 'justify',
                                        marginTop: '10px'
                                    }} pl={3}>
                                    View payment history.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={1} pb={6} pt={3}>
                                <img src={InosioIllustration} alt='illustration' style={{ width: "100%" }} />
                            </Grid>
                            <Grid item xs={12} p={1} display='flex' flexDirection={isOnMobileScreen ? 'column' : 'row'} justifyContent='center' >
                                {isOnMobileScreen ?
                                    <Button variant="outlined"
                                        style={{
                                            font: "14px Work Sans 400 !important",
                                            width: isOnMobileScreen ? '100%' : '140px',
                                            height: "49px",
                                            borderRadius: "24px",
                                            textTransform: "capitalize",
                                            backgroundColor: "#39A2DB",
                                            color: "white",
                                            marginBottom: isOnMobileScreen ? 8 : 0
                                        }} type="submit" onClick={onCreateAccount}>
                                        Create Account
                                    </Button>
                                    : <Button variant="outlined"
                                        style={{
                                            font: "14px Work Sans 400 !important",
                                            width: '140px',
                                            height: "49px",
                                            borderRadius: "24px",
                                            textTransform: "capitalize",
                                            backgroundColor: "#39A2DB",
                                            color: "white",
                                        }} type="submit" onClick={onCreateAccount}>
                                        Create Account
                                    </Button>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent >
        </Dialog >
    );
}

export default CreateYourAccountWithInosioModal;
